import styled from "styled-components"
import theme from "../../../theme"


export const Partners = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 20px;
  border: 4px solid ${theme.bg.light};
`

export const PartnersContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  @media (min-width: 1240px) {
    flex-direction: row;
    justify-content: center;
    max-width: 1240px;
  }
`

export const PartnerImage = styled.img`
  max-height: 100px;
  padding: 16px;

  @media (min-width: 1240px) {
    max-height: 125px;
    max-width: none;
  }
`
